// Tiny color helpers shared by JS patterns.
// Lives in `internal/` so the auto-discovery in `patterns-js/index.js`
// (non-recursive `require.context`) ignores it.

export function pickColor(colors, idx, fallback) {
  if (!Array.isArray(colors) || !colors.length) return fallback;
  return colors[idx] || colors[colors.length - 1] || fallback;
}

export function hexToRgb(hex) {
  if (!hex || typeof hex !== "string" || hex[0] !== "#") return null;
  let value = hex.slice(1);
  if (value.length === 3) {
    value = value.split("").map((c) => c + c).join("");
  }
  if (value.length !== 6) return null;
  return {
    r: parseInt(value.slice(0, 2), 16),
    g: parseInt(value.slice(2, 4), 16),
    b: parseInt(value.slice(4, 6), 16),
  };
}

export function rgba(hex, alpha) {
  const c = hexToRgb(hex);
  if (!c) return `rgba(255,255,255,${alpha})`;
  return `rgba(${c.r}, ${c.g}, ${c.b}, ${alpha})`;
}

// Smooth pseudo-noise from a sum of sines. Cheap, deterministic and
// "good enough" for flow fields and organic motion. Returns roughly -1..1.
export function smoothNoise(x, y, t = 0) {
  return (
    Math.sin(x * 0.9 + y * 0.4 + t) * 0.5 +
    Math.sin(x * 0.4 - y * 1.1 + t * 0.7) * 0.35 +
    Math.sin((x + y) * 0.6 + t * 0.3) * 0.2
  );
}
